<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <div class="row align-items-center py-4 mx-0">
              <div class="col-auto">
                <span class="unselectable" style="font-size: 25px; color: black;">อนุมัติใบขอซื้อ (PR)</span>
              </div>
            </div>
          </template>

          <template v-slot:body>
            <div class="mx-3">
              <b-row style="align-items: flex-end">
                <b-col cols="12" lg="3" class="pb-3">
                  <div class="iq-email-search d-flex">
                    <div style="width: 100%;">
                      <div class="form-group mb-0" style="height: 45px;">
                        <input v-model="search" @keydown="enterSearch" class="form-control" id="exampleInputEmail1" placeholder="Search"
                          style="width: 100%; height: 45px;">
                        <i style="color: #676767; top: 4px;" class="search-link ri-search-line" />
                      </div>
                    </div>
                  </div>
                </b-col>

                <b-col cols="6" lg="2" class="pb-3">
                  <b-text style="color: black; white-space: nowrap;">วันที่ใบขอซื้อ (เริ่มต้น)</b-text>
                  <div style="position: relative; margin-top: .4rem;" class="w-res-attendance time-picker-attendance">
                    <date-picker v-if="searchEndDate" placeholder="เลือกวันที่" id="datepicker-custom-1"
                      :config="optionsDatepickerStart" v-model="searchStartDate"></date-picker>
                    <date-picker v-else placeholder="เลือกวันที่" id="datepicker-custom-1"
                      :config="optionsDatepickerDefault" v-model="searchStartDate"></date-picker>
                    <i class="ri-calendar-line m-0 icon-calendar-edit" @click="onClickDatePicker(1)"
                      style="cursor: pointer;"></i>
                  </div>
                </b-col>

                <b-col cols="6" lg="2" class="pb-3">
                  <b-text style="color: black; white-space: nowrap;">วันที่ใบขอซื้อ (สิ้นสุด)</b-text>
                  <div style="position: relative; margin-top: .4rem;" class="w-res-attendance time-picker-attendance">
                    <date-picker v-if="searchStartDate" placeholder="เลือกวันที่" id="datepicker-custom-2"
                      :config="optionsDatepickerEnd" v-model="searchEndDate"></date-picker>
                    <date-picker v-else placeholder="เลือกวันที่" id="datepicker-custom-2"
                      :config="optionsDatepickerDefault" v-model="searchEndDate"></date-picker>
                    <i class="ri-calendar-line m-0 icon-calendar-edit" @click="onClickDatePicker(2)"
                      style="cursor: pointer;"></i>
                  </div>
                </b-col>

                <b-col cols="12" lg="auto" class="pb-3">
                  <b-button @click="getPurchaseRequisitionByClinic" type="button" variant="primary-custom"
                    class="w-100 btn-min-size" style="height: 45px;">
                    <i class="ri-search-line"></i>
                    ค้นหา
                  </b-button>
                </b-col>

                <b-col cols="auto" class="pb-3">
                  <div style="display: flex; align-items: center; height: 45px;">
                    <span class="mx-2 font-size-14 text-primary-custom">
                      {{ rows_pr.length > 0 ? (((currentPage - 1) * 10) + 1) + ' - ' + (((perPage *
                        currentPage) > rows_pr?.length) ? rows_pr.length : (perPage * currentPage)
                      ) + ' of ' + rows_pr_length : '0 of ' + rows_pr_length }} รายการ
                    </span>
                  </div>
                </b-col>
              </b-row>
            </div>

            <b-col cols="12">
              <div class="table-responsive">
                <div class="table-wrapper-purchase-requisition-approve">
                  <b-table bordered hover :items="rows_pr" :fields="columns_pr" :current-page="currentPage"
                  :per-page="perPage" @pagination="onPagination" :tbody-tr-class="rowClass"
                  thead-class="table-header-color">
                    <template v-slot:cell(no)="data">
                      <span>{{ ((currentPage - 1) * perPage) + data.index + 1 }}</span>
                    </template>
                    <template v-slot:cell(pr_no)="data">
                      <a @click.prevent="getPurchaseRequisitionById(data.item.pr_id)"
                        style="color: #0085FF; cursor: pointer;"><span>{{
                          data.item.pr_no ||
                          '-' }}</span></a>
                    </template>
                    <template v-slot:cell(pr_date)="data">
                      <span>{{ formatDate(data.item.pr_date) || '-' }}</span>
                    </template>
                    <template v-slot:cell(pr_status)="data">
                      <b-button v-if="data.item.pr_prs_id === '1bcae035-ca58-4b05-bc05-2ad401fd743e'"
                        variant=" iq-bg-warning-custom btn-warning-border" style="min-width: 100px; cursor:default;">{{
                          data.item.prs_name }}</b-button>
                      <b-button v-else-if="data.item.pr_prs_id === '2a3f0b53-fb6f-45eb-a14a-836f06f9ebdf'"
                        variant=" iq-bg-success-custom btn-success-border" style="min-width: 100px; cursor:default;">{{
                          data.item.prs_name }}</b-button>
                      <b-button v-else-if="data.item.pr_prs_id === '0576ad6c-a0f5-4225-9511-590347a8c57c'"
                        variant=" iq-bg-info-custom btn-info-border" style="min-width: 100px; cursor:default;">{{
                          data.item.prs_name }}</b-button>
                      <b-button v-else-if="data.item.pr_prs_id === '42cc02e5-32d7-4cc0-9c6b-1eb68612b265'"
                        variant=" bg-danger-custom" style="min-width: 100px;"
                        @click.prevent="reasonModal = true, reasonTextShow = data.item.pr_reason_not_approve;">{{
                          data.item.prs_name }}</b-button>
                      <span v-else>{{ '-' }}</span>
                    </template>
                    <template v-slot:cell(pr_approve_name)="data">
                      <span>{{ data.item.pr_approve_name || '-' }}</span>
                    </template>
                    <template v-slot:cell(management)="data">
                      <div style="display: flex;">
                        <b-button title="ดูรายงาน" variant=" iq-bg-report-custom btn-report-border mx-1" size="sm"
                          style="cursor: not-allowed;">
                          <i class="ri-article-line m-0"></i>
                        </b-button>
                        <b-button v-if="data.item.pr_prs_id === '1bcae035-ca58-4b05-bc05-2ad401fd743e'"
                          variant=" bg-success-custom mx-1" style="width: 100%;"
                          @click.prevent="purchaseRequisitionApprove(data.item.pr_id)">อนุมัติ
                        </b-button>
                        <b-button v-else variant=" bg-dark-custom mx-1" style="width: 100%; cursor: not-allowed;">อนุมัติ
                        </b-button>
                        <b-button v-if="data.item.pr_prs_id === '1bcae035-ca58-4b05-bc05-2ad401fd743e'"
                          variant=" bg-danger-custom mx-1" style="width: 100%;"
                          @click.prevent="reasonModalAnswer = true, reasonTextSave = '', pr_id_save = data.item.pr_id">ไม่อนุมัติ
                        </b-button>
                        <b-button v-else variant=" bg-dark-custom mx-1" style="width: 100%; cursor: not-allowed;">ไม่อนุมัติ
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </b-col>
            <b-pagination v-model="currentPage" :total-rows="rows_pr?.length" :per-page="perPage" align="center" />
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <!-- Reason Modal  -->
    <b-modal v-model="reasonModal" title="ไม่ผ่านการอนุมัติ" size='lg' centered @close.prevent="reasonModal = false"
      hide-footer>
      <div style="margin: 10px 30px;">
        <span style="word-break: break-word; color: black;">{{ reasonTextShow }}</span>
      </div>
    </b-modal>

    <!-- Reason Modal Answer  -->
    <b-modal v-model="reasonModalAnswer" title="เหตุผลที่ไม่อนุมัติ" size='lg' centered
      @close.prevent="reasonModalAnswer = false" no-close-on-backdrop>
      <template #modal-title>
        เหตุผลที่ไม่อนุมัติ <span style="color: red;">*</span>
      </template>
      <b-form-textarea type="text" v-model="reasonTextSave" placeholder="ข้อคิดเห็น"
        style="padding-right: 1rem; height: 100px; justify-items: flex-start;"></b-form-textarea>
      <template #modal-footer>
        <div class="w-100" style="display: flex; justify-content: flex-end; gap: 0.5rem;">
          <b-button style="border-radius: 0.5rem; padding: 0 1.1rem !important;" variant="none"
            class="btn-min-size bg-save-custom" size="sm" @click.prevent="purchaseRequisitionNotApprove">
            <i class="save-data_ct" />บันทึก
          </b-button>
          <b-button variant="none" class="btn-min-size bg-danger-custom" style="border-radius: 0.5rem;" size="sm"
            @click.prevent="reasonModalAnswer = false">
            ยกเลิก
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Detail PurchaseRequisition Modal  -->
    <b-modal v-model="detailPurchaseRequisitionModal" title="รายละเอียดใบขอซื้อ" size='xl' centered
      @close.prevent="detailPurchaseRequisitionModal = false" hide-footer>
      <b-row>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">เลขที่ใบขอซื้อ : {{ purchaseRequisitionDetail.pr_no }}</b-text>
        </b-col>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">วันที่ขอซื้อ : {{ purchaseRequisitionDetail.pr_date }}</b-text>
        </b-col>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">อ้างอิงเลขใบขอซื้อ : {{ purchaseRequisitionDetail.pr_ref_no || '-'
          }}</b-text>
        </b-col>
      </b-row>
      <hr style="width: calc(100% + 32px); height: 1px; color: #CCC; margin-left: -16px;" />
      <b-row>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">รายการสินค้า</b-text>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="table-responsive">
            <b-table bordered hover :items="rows_product.data" :fields="columns_product" :tbody-tr-class="rowClass"
              thead-class="table-header-color">
              <template v-for="(column) in columns_product" v-slot:[`cell(${column.key})`]="data">
                <template v-if="column.key === 'no'">
                  <span :key="column.key">{{ data.index + 1 }}</span>
                </template>
                <template v-if="column.key === 'prod_no'">
                  <span :key="column.key">{{ data.item.no || '-' }}</span>
                </template>
                <template v-if="column.key === 'prod_name'">
                  <span :key="column.key">{{ data.item.name || '-' }}</span>
                </template>
                <template v-if="column.key === 'prod_quantity'">
                  <span :key="column.key">{{ formatNumber(data.item.quantity) }}</span>
                </template>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
      <hr style="width: calc(100% + 32px); height: 1px; color: #CCC; margin-left: -16px;" />
      <b-row>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">รายการวัตถุดิบ</b-text>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="table-responsive">
            <b-table bordered hover :items="rows_rawmat.data" :fields="columns_rawmat" :tbody-tr-class="rowClass"
              thead-class="table-header-color">
              <template v-for="(column) in columns_rawmat" v-slot:[`cell(${column.key})`]="data">
                <template v-if="column.key === 'no'">
                  <span :key="column.key">{{ data.index + 1 }}</span>
                </template>
                <template v-if="column.key === 'rawmat_category'">
                  <span :key="column.key">{{ data.item.mg_name || '-' }}</span>
                </template>
                <template v-if="column.key === 'rawmat_brand'">
                  <span :key="column.key">{{ data.item.mb_name || '-' }}</span>
                </template>
                <template v-if="column.key === 'ramat_type'">
                  <span :key="column.key">{{ data.item.mt_name || '-' }}</span>
                </template>
                <template v-if="column.key === 'rawmat_unit'">
                  <span :key="column.key">{{ data.item.unit_name || '-' }}</span>
                </template>
                <template v-if="column.key === 'rawmat_quantity'">
                  <span :key="column.key">{{ data.item.quantity || '-' }}</span>
                </template>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="6" xl style="padding-top: 5px; padding-bottom: 5px;">
          <b-text style="color: black; word-break: break-word;">ข้อคิดเห็น : {{ purchaseRequisitionDetail.pr_remark || '-'
          }}</b-text>
        </b-col>
      </b-row>
    </b-modal>
  </b-container>
</template>

<style>
.table-wrapper-purchase-requisition-approve {
  overflow-x: auto;
  width: 100%;
}

.table-wrapper-purchase-requisition-approve .sticky-col-right-td {
  position: sticky;
  right: 0;
  background: white;
  z-index: 5;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  outline: 1px solid #dee2e6;
  box-sizing: border-box;
}

.table-wrapper-purchase-requisition-approve .sticky-col-right-th {
  position: sticky;
  right: 0;
  background: #024187;
  z-index: 5;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  outline: 1px solid #dee2e6;
  box-sizing: border-box;
}
</style>

<script>
import { xray } from '../../config/pluginInit'
// import router from '@/router'
import Vue from 'vue'
import Axios from 'axios'
import moment from 'moment'
import { configAPI } from '../../configBase'

const iconDate = {
  time: 'fas fa-clock',
  date: 'fas fa-calendar',
  up: 'fas fa-chevron-up',
  down: 'fas fa-chevron-down',
  previous: 'fas fa-chevron-left',
  next: 'fas fa-chevron-right',
  today: 'fas fa-calendar-day',
  clear: 'fas fa-trash-alt',
  close: 'fas fa-times'
}

export default {
  name: 'PurchaseRequisitionApprove',

  components: {},

  data () {
    return {
      clnId: null,
      userId: null,
      search: '',
      searchStartDate: null,
      searchEndDate: null,
      columns_pr: [
        { label: 'ลำดับ', key: 'no', class: 'text-center table-size-100-300' },
        {
          label: 'เลขที่ใบขอซื้อ',
          key: 'pr_no',
          class: 'text-center table-size-200-400'
        },
        {
          label: 'วันที่ใบขอซื้อ',
          key: 'pr_date',
          class: 'text-center table-size-200-400'
        },
        {
          label: 'สถานะ',
          key: 'pr_status',
          class: 'text-center table-size-200-400'
        },
        {
          label: 'ชื่อผู้อนุมัติ',
          key: 'pr_approve_name',
          class: 'text-center table-size-200-400'
        },
        {
          label: 'Management',
          key: 'management',
          class: 'text-center table-size-300-500',
          tdClass: 'sticky-col-right-td',
          thClass: 'sticky-col-right-th'
        }
      ],
      rows_pr: [],
      rows_pr_length: 0,
      currentPage: 1,
      perPage: 10,
      reasonModal: false,
      reasonModalAnswer: false,
      reasonTextShow: '',
      reasonTextSave: '',
      pr_id_save: null,
      optionsDatepickerDefault: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        useStrict: false,
        minDate: false,
        maxDate: false,
        icons: iconDate
      },
      optionsDatepickerStart: {
        format: 'DD/MM/YYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        useStrict: false,
        minDate: false,
        maxDate: false,
        icons: iconDate
      },
      optionsDatepickerEnd: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        useStrict: false,
        minDate: false,
        maxDate: false,
        icons: iconDate
      },
      detailPurchaseRequisitionModal: false,
      purchaseRequisitionDetail: {},
      columns_product: [
        { label: 'ลำดับ', key: 'no', class: 'text-center table-size-100-300' },
        {
          label: 'รหัสสินค้า',
          key: 'prod_no',
          class: 'text-center table-size-200-400 ellips'
        },
        {
          label: 'ชื่อสินค้า',
          key: 'prod_name',
          class: 'text-center table-size-200-400 ellips'
        },
        {
          label: 'จำนวน',
          key: 'prod_quantity',
          class: 'text-center table-size-200-400'
        }
      ],
      rows_product: {
        data: [],
        oldData: []
      },
      columns_rawmat: [
        { label: 'ลำดับ', key: 'no', class: 'text-center table-size-100-300' },
        {
          label: 'หมวดหมู่',
          key: 'rawmat_category',
          class: 'text-center table-size-200-400'
        },
        {
          label: 'แบรนด์',
          key: 'rawmat_brand',
          class: 'text-center table-size-200-400 ellips'
        },
        {
          label: 'ประเภท',
          key: 'ramat_type',
          class: 'text-center table-size-200-400 ellips'
        },
        {
          label: 'หน่วยนับ',
          key: 'rawmat_unit',
          class: 'text-center table-size-200-400'
        },
        {
          label: 'จำนวน',
          key: 'rawmat_quantity',
          class: 'text-center table-size-200-400'
        }
      ],
      rows_rawmat: {
        data: [],
        oldData: []
      }
    }
  },

  computed: {},

  watch: {
    searchStartDate: function (newDate) {
      this.optionsDatepickerEnd.minDate = newDate
    },
    searchEndDate: function (newDate) {
      this.optionsDatepickerStart.maxDate = newDate
    }
  },

  async mounted () {
    this.clnId = JSON.parse(sessionStorage.getItem('user')).cln_id || null
    this.userId = JSON.parse(sessionStorage.getItem('user')).usr_id || null

    await this.getPurchaseRequisitionByClinic()

    xray.index()
  },

  methods: {
    async enterSearch (e) {
      if (e.key === 'Enter') {
        await this.getPurchaseRequisitionByClinic()
      }
    },
    formatDate (date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return '-'
      }
    },

    formatNumber (number) {
      if (number) {
        return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    },

    formatTel (tel) {
      if (tel) {
        let formatTel = tel.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
        return formatTel
      } else {
        return ''
      }
    },

    SwalError (error, message) {
      Vue.swal.fire({
        title: `<span class="" style="font-size: 25px color: black text-align: center">${message}</span>`,
        html: '<span>' + error + '</span>',
        icon: 'warning',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: true,
        confirmButtonText:
          '<b-button style="font-size: 14px text-align: center">ตกลง</b-button>',
        confirmButtonColor: '#089bab',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1'
        }
      })
    },

    rowClass (item, type) {
      if (!item || type !== 'row') return
      if (item.no % 2 === 1) return 'table-body-color'
    },

    onClickDatePicker (number) {
      let datePicker = null
      datePicker = document.getElementById(`datepicker-custom-${number}`)
      datePicker.focus()
    },

    onPagination (page) {
      this.currentPage = page
    },

    async getPurchaseRequisitionByClinic () {
      const searchData = {
        search: this.search.trim() || null,
        searchStartDate: this.searchStartDate
          ? moment(this.searchStartDate, 'DD/MM/YYYY').startOf('day')
          : null,
        searchEndDate: this.searchEndDate
          ? moment(this.searchEndDate, 'DD/MM/YYYY').endOf('day')
          : null
      }

      await Axios.request({
        method: 'post',
        url: `${configAPI.SALE_PORT}/api/purchaseRequisition/clinic/${this.clnId}/filterPR`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: searchData
      })
        .then((response) => {
          this.rows_pr = response.data.data
          this.rows_pr_length = response.data.dataCount
        })
        .catch((error) => {
          this.SwalError(error.message, 'เกิดข้อผิดพลาดในดึงข้อมูล')
        })
    },

    async purchaseRequisitionApprove (prId) {
      const temp = {
        user_id: this.userId
      }

      Vue.swal
        .fire({
          title:
            '<span class="" style="font-size: 23px color: black text-align: center">คุณมั่นใจว่าจะอนุมัติใบขอซื้อนี้ใช่หรือไม่?</span>',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText:
            '<b-button style="font-size: 14px text-align: center">ใช่</b-button>',
          confirmButtonColor: '#0DC268',
          cancelButtonText:
            '<b-button style="font-size: 14px text-align: center">ไม่</b-button>',
          cancelButtonColor: '#E03C3C',
          customClass: {
            confirmButton: 'custom-confirm-button-class mx-1',
            cancelButton: 'custom-confirm-button-class mx-1'
          }
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await Axios.request({
              method: 'POST',
              url: `${configAPI.SALE_PORT}/api/purchaseRequisition/clinic/${this.clnId}/approvePurchaseRequisition/${prId}`,
              headers: {
                'Content-Type': 'application/json'
              },
              data: temp
            })
              .then((response) => {
                Vue.swal
                  .fire({
                    title:
                      '<span class="" style="font-size: 25px color: black text-align: center">อนุมัติสำเร็จ</span>',
                    icon: 'success',
                    showCancelButton: false,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    timer: 1500
                  })
                  .then(async () => {
                    window.location.reload()
                  })
              })
              .catch((err) => {
                this.SwalError(err.message, 'ลบข้อมูลไม่สำเร็จ')
              })
          }
        })
    },

    async purchaseRequisitionNotApprove () {
      if (this.reasonTextSave === '' || this.reasonTextSave === null) {
        this.SwalError('', 'กรุณากรอกเหตุผลที่ไม่อนุมัติ')
      } else {
        const temp = {
          user_id: this.userId,
          reasonTextSave: this.reasonTextSave
        }

        Vue.swal
          .fire({
            title:
              '<span class="" style="font-size: 22px color: black text-align: center">คุณมั่นใจว่าจะไม่อนุมัติใบขอซื้อนี้ใช่หรือไม่?</span>',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText:
              '<b-button style="font-size: 14px text-align: center">ใช่</b-button>',
            confirmButtonColor: '#0DC268',
            cancelButtonText:
              '<b-button style="font-size: 14px text-align: center">ไม่</b-button>',
            cancelButtonColor: '#E03C3C',
            customClass: {
              confirmButton: 'custom-confirm-button-class mx-1',
              cancelButton: 'custom-confirm-button-class mx-1'
            }
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await Axios.request({
                method: 'POST',
                url: `${configAPI.SALE_PORT}/api/purchaseRequisition/clinic/${this.clnId}/notApprovePurchaseRequisition/${this.pr_id_save}`,
                headers: {
                  'Content-Type': 'application/json'
                },
                data: temp
              })
                .then((response) => {
                  Vue.swal
                    .fire({
                      title:
                        '<span class="" style="font-size: 25px color: black text-align: center">ไม่อนุมัติสำเร็จ</span>',
                      icon: 'success',
                      showCancelButton: false,
                      showConfirmButton: false,
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      timer: 1500
                    })
                    .then(async () => {
                      window.location.reload()
                    })
                })
                .catch((err) => {
                  this.SwalError(err.message, 'ลบข้อมูลไม่สำเร็จ')
                })
            }
          })
      }
    },

    async getPurchaseRequisitionById (prId) {
      await Axios.request({
        method: 'GET',
        url: `${configAPI.SALE_PORT}/api/purchaseRequisition/clinic/${this.clnId}/getPurchaseRequisitionByIdModal/${prId}`,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((res) => {
          const tempData = res.data.data[0]

          this.purchaseRequisitionDetail = {
            pr_no: tempData?.pr_no || null,
            pr_date: tempData?.pr_date
              ? moment(tempData?.pr_date).format('DD/MM/YYYY')
              : '',
            pr_ref_no: tempData?.pr_ref_no || null,
            pr_remark: tempData?.pr_remark || null
          }

          const arrList = {
            prod_list: [],
            rm_List: []
          }

          for (let item of tempData?.pr_item_list) {
            item.is_select = true
            item.quantity = item.pri_amount
            item.pri_id = prId ? null : item.pri_id

            if (item.pri_prd_id) {
              item.id = item.pri_prd_id

              const dataName = {
                no: item.pri_item_data.no,
                name: item.pri_item_data.name
              }

              arrList.prod_list.push({ ...item, ...dataName })
            }

            if (item.pri_mat_id) {
              item.id = item.pri_mat_id

              const dataName = {
                mg_name: item.pri_item_data.mg_name,
                mb_name: item.pri_item_data.mb_name,
                mt_name: item.pri_item_data.mt_name,
                unit_name: item.pri_item_data.unit_name
              }

              arrList.rm_List.push({ ...item, ...dataName })
            }

            this.rows_product.data = arrList.prod_list
            this.rows_rawmat.data = arrList.rm_List
          }

          this.detailPurchaseRequisitionModal = true
        })
        .catch((err) => {
          this.SwalError(err, 'Error')
        })
    }
  }
}
</script>
